// client/src/services/enhancedSearchService.js

/**
 * Enhanced Face Search Service 
 * This service handles communication with our enhanced analysis API
 * while keeping the details of the third-party provider hidden.
 */

export const enhancedSearchService = {
  /**
   * Analyze an image using enhanced face analysis
   * @param {File} imageFile - The image file to analyze
   * @returns {Promise<Object>} - The analysis results
   */
  analyzeImage: async (imageFile, { signal } = {}) => {
    try {
      // Create a FormData object to send the image
      const formData = new FormData();
      formData.append('image', imageFile);
      
      // Make the initial request to our proxy endpoint
      console.log('Submitting image for enhanced analysis...');
      
      const response = await fetch('/api/enhanced-analysis', {
        method: 'POST',
        body: formData,
        signal,
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Enhanced analysis failed');
      }
      
      const data = await response.json();
      
      // Process the response into a standardized format
      return {
        enhancedResults: true,
        source: "Third-party API 1",
        matches: data.matches.map(match => ({
          id: match.id,
          score: match.score,
          url: match.url,
          thumbnail: match.image_url || match.thumbnail || null,
          metadata: match.metadata || {}
        })),
        queryInfo: {
          timestamp: data.timestamp,
          searchId: data.query?.searchId || 'unknown'  
        }
      };
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      console.error('Enhanced analysis error:', error);
      return {
        enhancedResults: false,
        source: "Third-party API 1",
        error: error.message || 'Unable to perform enhanced analysis'
      };
    }
  }
};
